import React, { useMemo } from 'react';
import clsx from 'clsx';
import style from './style.module.scss';
import { observer } from 'mobx-react';

const HockeyViewRegular = observer(({ quarter, item }) => {
  const {
    sortedHomeScores,
    sortedAwayScores,
    period,
    getTracker,
    special
  } = item;

  const score = useMemo(() => {
    let result = {
      home: '',
      away: ''
    };

    if (sortedHomeScores.length > 0) {
      const homeScoreArr = sortedHomeScores.filter(
        (score) => quarter.value === score.period
      );

      if (homeScoreArr.length > 0) {
        result.home = homeScoreArr[0].score;
      }
    }

    if (sortedAwayScores.length > 0) {
      const awayScoreArr = sortedAwayScores.filter(
        (score) => quarter.value === score.period
      );

      if (awayScoreArr.length > 0) {
        result.away = awayScoreArr[0].score;
      }
    }

    return result;
  }, [quarter, sortedHomeScores, sortedAwayScores]);

  const quarterSpecial = useMemo(() => {
    return {
      home: {
        firstPoint:
          special.firstPointPeriod === quarter.value &&
          special.firstPoint === 'HOME',
        firstPower:
          special.firstPowerPeriod === quarter.value &&
          special.firstPower === 'HOME'
      },
      away: {
        firstPoint:
          special.firstPointPeriod === quarter.value &&
          special.firstPoint === 'AWAY',
        firstPower:
          special.firstPowerPeriod === quarter.value &&
          special.firstPower === 'AWAY'
      }
    };
  }, [quarter, special]);

  return (
    <dl
      className={clsx(
        style.item,
        quarter.value === period &&
          getTracker.status === 'progress' &&
          style.on,
        quarter.value > 3 && style.notSpecial
      )}
    >
      <dt>{quarter.key}</dt>
      <dd>
        {score.away}
        <span className={style.special}>
          {quarterSpecial.away.firstPoint && (
            <em className={style.s_first}>득</em>
          )}
          {quarterSpecial.away.firstPower && (
            <em className={style.s_power}>P</em>
          )}
        </span>
      </dd>
      <dd>
        {score.home}
        <span className={style.special}>
          {quarterSpecial.home.firstPoint && (
            <em className={style.s_first}>득</em>
          )}
          {quarterSpecial.home.firstPower && (
            <em className={style.s_power}>P</em>
          )}
           
        </span>
      </dd>

      <dd className={style.sum}>{score.home + score.away}</dd>
    </dl>
  );
});

export default HockeyViewRegular;
